export enum LanguageEnum {
	'Indonesia' = 'ID',
	'English' = 'EN',
}
